import { render, staticRenderFns } from "./DeliveryDateHistoryLogsModal.vue?vue&type=template&id=1a68acfc"
import script from "./DeliveryDateHistoryLogsModal.vue?vue&type=script&lang=ts"
export * from "./DeliveryDateHistoryLogsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports